import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Stethoscope } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Loading } from "@/components/common/Common";
import { LevelIcon, RealBadge } from "@/components/common/Badges";
import { useScope } from "@/context/ScopeContext";
import { api, errMsg } from "@/lib/api";

export default function Diagnostics() {
  const { accountId } = useScope();
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => { setBusy(true); try { setRes((await api.get("/diagnostics", { params: accountId ? { account_id: accountId } : {} })).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  return (
    <div>
      <PageHeader eyebrow="Saúde da conta" title="Diagnóstico da conta" desc="Verificações automáticas sobre a conta Google Ads selecionada e seus rascunhos." actions={<Button className="rounded-full" onClick={run} disabled={busy} data-testid="run-diagnostics-button"><Stethoscope className="h-4 w-4 mr-1" />Executar diagnóstico</Button>} />
      {busy && <Loading label="Verificando..." />}
      {res && (
        <div className="space-y-10 reveal">
          <section>
            <div className="flex items-center gap-3 mb-4"><h2 className="text-lg font-semibold">Conta Google Ads</h2>{res.account && <RealBadge />}</div>
            {!accountId && <p className="text-sm text-muted-foreground">Nenhuma conta selecionada — <Link className="underline" to="/app/google-ads">conecte o Google Ads</Link>.</p>}
            {res.error && <p className="text-sm text-rose-500" data-testid="diagnostics-error">{res.error}</p>}
            {res.account && <div className="surface divide-y">{res.account.map((c, i) => (
              <div key={i} className="p-4 grid sm:grid-cols-[110px_260px_1fr] gap-2 items-start" data-testid="diagnostic-check"><LevelIcon level={c.level} /><p className="font-medium text-sm">{c.title}</p><p className="text-sm text-muted-foreground">{c.detail}</p></div>
            ))}</div>}
          </section>
          <section>
            <h2 className="text-lg font-semibold mb-4">Rascunhos de campanha</h2>
            {!res.drafts.length && <p className="text-sm text-muted-foreground">Nenhum rascunho.</p>}
            <div className="space-y-3">{res.drafts.map((d) => (
              <Link key={d.id} to={`/app/campaigns/${d.id}`} className="block surface p-4 hover:bg-secondary/40" data-testid="diagnostic-draft">
                <p className="font-medium text-sm">{d.name}</p>
                {!d.issues.length ? <p className="mt-2"><LevelIcon level="ok" /></p> : d.issues.map((i, k) => <div key={k} className="flex gap-3 mt-2 text-sm"><LevelIcon level={i.level} />{i.text}</div>)}
              </Link>
            ))}</div>
          </section>
        </div>
      )}
    </div>
  );
}
